import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../../css/navbar.css';
import logo from '../../../assets/images/matiramlogo2.png';

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 100);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Function to close menu when a link is clicked
  const handleNavClick = () => {
    setMenuOpen(false);
  };

  return (
    <header className={`header ${scrolled ? 'scrolled' : ''}`}>
      <div className="logo">
        <Link to="/">
          <img src={logo} alt="Your Logo" className="logo-image" />
          <span className="logoname">
            MatiRam <span>InfoTech</span>
          </span>
        </Link>
      </div>

      <nav className={`nav-links ${menuOpen ? 'open' : ''}`}>
        <Link
          to="/"
          className={`nav-link ${scrolled ? 'scrolled' : ''}`}
          onClick={handleNavClick}
        >
          Home
        </Link>
        <Link
          to="/about"
          className={`nav-link ${scrolled ? 'scrolled' : ''}`}
          onClick={handleNavClick}
        >
          About
        </Link>
        <Link
          to="/service"
          className={`nav-link ${scrolled ? 'scrolled' : ''}`}
          onClick={handleNavClick}
        >
          Services
        </Link>
        <Link
          to="/contact"
          className={`nav-link ${scrolled ? 'scrolled' : ''}`}
          onClick={handleNavClick}
        >
          Contact
        </Link>
      </nav>

      {/* Hamburger Menu for Mobile */}
      <div
        className={`hamburger-menu ${menuOpen ? 'active' : ''}`}
        onClick={() => setMenuOpen(!menuOpen)}
      >
        <div></div>
        <div></div>
        <div></div>
      </div>
    </header>
  );
};

export default Navbar;
